/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseInput from '../form-components/BaseInput.vue';
import BaseSelect from '../form-components/BaseSelect.vue';
import RadioButtons from '../form-components/RadioButtons.vue';


const __vue_script__ = {
    name: 'TimeshiftModal',

    components: {
        BaseInput,
        BaseSelect,
        RadioButtons,
    },

    props: {
        event: {
            type: Object,
            required: true
        },
        fpType: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            default: () => []
        },
        onSuccess: {
            type: Function,
            required: true,
        }
    },

    data() {
        return {
            amount: 1,
            direction: 'later',
            directionChoices: ['sooner', 'later']
                .map(d => ({
                    value: d,
                    label: this.$t(`listings.messages.${d}`),
                })),
            submitting: false,
            title: this.$t('listings.actions.time_shift'),
            timeUnit: {
                value: 'minutes',
                label: this.$t('listings.messages.minutes'),
            },
            timeUnitChoices: ['minutes', 'hours', 'days']
                .map(d => ({
                    value: d,
                    label: this.$t(`listings.messages.${d}`),
                })),
        };
    },

    computed: {
        description() {
            return this.getLabel('timeshift_of', true);
        },
        moveLabel() {
            return this.getLabel('move');
        },
        submitLabel() {
            return this.getLabel('shift', true);
        },
    },

    methods: {
        getLabel(key, showCount = false) {
            const prefix = this.$t(`listings.messages.${key}`);
            const count = this.items.length;
            return `${prefix} ${showCount ? count + ' ' : ''}${this.fpType}${count === 1 ? '' : 's'}`;
        },

        async submit() {
            const multiplier = {
                minutes: 60,
                hours: 60 * 60,
                days: 60 * 60 * 24,
            };
            let seconds = this.amount * multiplier[this.timeUnit.value];
            if (this.direction === 'sooner') {
                seconds = -seconds;
            }
            try {
                await this.$services.documents.timeShiftDocs(
                    this.event.id,
                    this.fpType,
                    seconds,
                    this.items.map(d => d._id),
                );
                this.$emit('close');
                this.onSuccess();
            } catch (err) {
                console.error('[TimeshiftModal] time-shift request failed', err);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulk-editor modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.description))]),_c('radio-buttons',{attrs:{"inline":"inline","options":_vm.directionChoices,"name":"direction","label":_vm.moveLabel},model:{value:(_vm.direction),callback:function ($$v) {_vm.direction=$$v},expression:"direction"}}),_c('base-input',{attrs:{"type":"number","name":"amount","label":_vm.$t('listings.messages.shift_by')},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}}),_c('base-select',{attrs:{"options":_vm.timeUnitChoices,"name":"unit"},model:{value:(_vm.timeUnit),callback:function ($$v) {_vm.timeUnit=$$v},expression:"timeUnit"}})],1),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.submitting},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-primary",attrs:{"status":_vm.submitting},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.submitLabel))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TimeshiftModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__